var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"register-success"},[_c('p',{staticClass:"success"},[_vm._v("恭喜您已注册成功！ ")]),_c('a',{staticClass:"download",attrs:{"href":"http://t.cn/Aijv8II4"}},[_vm._v("去下载")])])])
}]

export { render, staticRenderFns }